import React from 'react';

// Import the icon assets
import iconBeratung from '../assets/personliche_beratung.png';
import iconGestaltung from '../assets/flexible_gestaltung.png';
import iconUmsetzung from '../assets/schnelle_umsetzung.png';
import iconMaterialien from '../assets/hochwertige_materialien.png';

// Optional: Create a data structure for easier mapping
const detailItemsData = [
  {
    id: 1,
    icon: iconBeratung,
    title: 'Persönliche Beratung',
    text: 'Bei uns stehst du im Mittelpunkt. Wir beraten dich individuell und finden gemeinsam das perfekte Design für dein Projekt.',
    altText: 'Beratung Icon' // Alt text for accessibility
  },
  {
    id: 2,
    icon: iconGestaltung,
    title: 'Flexible Gestaltung',
    text: 'Deine Ideen zählen! Ob Textilien, Tassen oder Deko – wir setzen deine Wünsche präzise und kreativ um.',
    altText: 'Gestaltung Icon'
  },
  {
    id: 3,
    icon: iconUmsetzung,
    title: 'Schnelle Umsetzung',
    text: 'Keine langen Wartezeiten: Dank moderner Technik und effizienter Abläufe erhältst du dein Produkt in kürzester Zeit.',
    altText: 'Umsetzung Icon'
  },
  {
    id: 4,
    icon: iconMaterialien,
    title: 'Hochwertige Materialien',
    text: 'Für langlebige Ergebnisse verwenden wir nur ausgesuchte Vinylfolien und Textilien – Qualität, die du sehen und fühlen kannst.',
    altText: 'Materialien Icon'
  }
];


function Details() {
  return (
    <section id="details" className="section details-section">
      <div className="container">
        <h2>Unsere Stärken</h2>
        <div className="details-grid">
          {/* Map over the data array */}
          {detailItemsData.map((item) => (
            <div key={item.id} className="detail-item">
               {/* Add the image tag */}
              <img src={item.icon} alt={item.altText} className="detail-icon" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Details;